import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { propTypes } from 'shared/proptypes/User';
import Tooltip from 'shared/components/Tooltip';
import { STATIC_BASE_URL } from 'shared/routes';
import styles from './Avatar.module.scss';

const Avatar = ({ user, img, iconClassName, transparent, className, classNames, title, withExternalLabel }) => {
  const { t } = useTranslation('common');

  return (
    <span className={cn(styles.avatar, className, classNames.wrapper, { [styles.transparent]: transparent })}>
      {(user && user.photo) || img ? (
        <span className={cn(styles.img, classNames.img)}>
          <img
            src={user.photo ? `${STATIC_BASE_URL}${user.photo}` : img}
            title={title || `${user.firstname || ''} ${user.lastname || ''}`}
            alt=""
          />
        </span>
      ) : iconClassName ? (
        <span className={cn(styles.noPhoto, classNames.noPhoto)} title={title}>
          <i className={iconClassName} />
        </span>
      ) : (
        <span className={cn(styles.noPhoto, classNames.noPhoto)} title={user ? `${user.firstname || ''} ${user.lastname || ''}` : title}>
          <span className={classNames.letters}>
            {user ? `${(user.firstname || '').toUpperCase()[0] || ''}${(user.lastname || '').toUpperCase()[0] || ''}` : ''}
          </span>
        </span>
      )}
      {withExternalLabel && user && user.external && (
        <Tooltip content={t('userProfile.external.tag')} spanClassName={styles.externalBadge}>
          <i className="las la-cloud-upload-alt" />
        </Tooltip>
      )}
    </span>
  );
};

Avatar.propTypes = {
  user: PropTypes.shape(propTypes),
  img: PropTypes.string,
  iconClassName: PropTypes.string,
  transparent: PropTypes.bool,
  className: PropTypes.string,
  classNames: PropTypes.object,
  title: PropTypes.string,
  withExternalLabel: PropTypes.bool,
};

Avatar.defaultProps = {
  user: {},
  img: null,
  iconClassName: null,
  transparent: false,
  className: null,
  classNames: {
    wrapper: '',
    img: '',
    noPhoto: '',
    letters: ''
  },
  title: null,
  withExternalLabel: false,
};

export default Avatar;
